var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-container main-menu-content"},[_c('horizontal-nav-menu-items',{attrs:{"items":_vm.navMenuItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }